import { formatDate } from '../../../utils/format';

const formatDocDate = value => formatDate(value, null);

export const mapSupportDocumentItem = item => {
  const documentUpload = item?.documentUpload ?? item?.DocumentUpload ?? null;
  const documentUploadId =
    item.documentUploadId ??
    item.DocumentUploadId ??
    documentUpload?.id ??
    documentUpload?.Id ??
    null;

  return {
    id: item.id ?? item.Id ?? null,
    customFileName:
      (item.customFileName ?? item.CustomFileName)
        ? String(item.customFileName ?? item.CustomFileName).replace(
            /\.[^/.]+$/,
            ''
          )
        : null,
    documentName:
      documentUpload?.documentName ??
      documentUpload?.DocumentName ??
      item.documentName ??
      item.DocumentName ??
      null,
    documentUploadId,
    actualUrl: item.link ?? item.Link ?? null,
    isMasterDocument: !(item.link ?? item.Link),
    isShowToDMUT: item.isShowToDMUT ?? item.IsShowToDMUT ?? false,
    lastUpdated: formatDocDate(item.updatedDate ?? item.UpdatedDate),
    createdDate: formatDocDate(item.createdDate ?? item.CreatedDate),
    counterId: null,
    hasCounter: false,
  };
};

export const mapCounterDocumentItem = item => {
  const documentUpload = item?.documentUpload ?? item?.DocumentUpload ?? null;
  const procurementDocument =
    item?.procurementDocument ?? item?.ProcurementDocument ?? null;

  return {
    id:
      item.id ??
      item.Id ??
      item.procurementDocumentCounterId ??
      item.ProcurementDocumentCounterId ??
      null,
    procurementDocumentId:
      item.procurementDocumentId ??
      item.ProcurementDocumentId ??
      procurementDocument?.id ??
      procurementDocument?.Id ??
      null,
    documentUploadId:
      item.documentUploadId ??
      item.DocumentUploadId ??
      documentUpload?.id ??
      documentUpload?.Id ??
      null,
    fileName:
      item.customFileName ??
      item.CustomFileName ??
      item.fileName ??
      item.FileName ??
      null,
    actualUrl:
      item.fileUrl ??
      item.FileUrl ??
      documentUpload?.fileUrl ??
      documentUpload?.FileUrl ??
      item.link ??
      item.Link ??
      documentUpload?.link ??
      documentUpload?.Link ??
      null,
    lastUpdated: formatDocDate(item.updatedDate ?? item.UpdatedDate),
    createdDate: formatDocDate(item.createdDate ?? item.CreatedDate),
  };
};

export const isOtherSupportDocument = (item, customCategory) =>
  Boolean(item.customFileName) ||
  Boolean(
    customCategory?.value && item.documentUploadId === customCategory.value
  );

export const mergeDocumentsWithCounters = (documents, counters) => {
  const counterByProcurementDocId = new Map();
  counters.forEach(counter => {
    if (!counter.procurementDocumentId) return;
    counterByProcurementDocId.set(
      String(counter.procurementDocumentId),
      counter
    );
  });

  return documents.map(doc => {
    const counter = counterByProcurementDocId.get(String(doc.id));
    if (!counter) return doc;

    return {
      ...doc,
      counterId: counter.id,
      hasCounter: true,
      actualUrl: counter.actualUrl || doc.actualUrl,
      updated: counter.lastUpdated || counter.createdDate || doc.updated,
      isMasterDocument: false,
    };
  });
};
